module.exports = __webpack_public_path__ + "img/形状 1140.ff86ea84.png";